import { useMutation } from '@tanstack/react-query';
import {
    OrganizationDto,
    UpdateOrganizationBookingPaymentDeadlineDto,
} from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

// Updates the per-tenant Stripe checkout expiry. The API enforces 5..1430 minutes
// (see UpdateOrganizationBookingPaymentDeadlineDto on the API side); errors are
// surfaced to the caller so the form can show the validation message.
export const useUpdateBookingPaymentDeadline = (
    organizationId: string,
    onSuccess: () => void,
) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateBookingPaymentDeadline', organizationId],
        mutationFn: (body: UpdateOrganizationBookingPaymentDeadlineDto) =>
            apiClient.fetchApi<OrganizationDto, UpdateOrganizationBookingPaymentDeadlineDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/booking-payment-deadline`,
                body,
            }),
        onSuccess: (data) => {
            onSuccess();
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
        },
    });
};
